import compatibilitiesList from './actions/compatibilitiesList';
import compatibilityChange from './actions/compatibilityChange';
import compatibilityCreate from './actions/compatibilityCreate';
import compatibilityDetail from './actions/compatibilityDetail';
import getCompatibilities from './getters/getCompatibilities';
import compatibilitiesUpload from './mutations/compatibilitiesUpload';

const actions = {
    compatibilitiesList,
    compatibilityChange,
    compatibilityCreate,
    compatibilityDetail
};

const mutations = {
    compatibilitiesUpload
};

const getters = {
    getCompatibilities
};

export default { actions, mutations, getters };
